/**
 * Class to check and add a title to iframes on the page.
 *
 * This is mainly for Accessibility purposes and helps making sure iframes have some kind of title at least, even if its a very generic one.
 */
class IframeTitleChecker {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', () => this.checkIframes() );
	}

	/**
	 * Checks all iframes on the page and adds a title if missing.
	 *
	 */
	checkIframes() {
		const iframes = document.querySelectorAll( 'iframe' );

		iframes.forEach( iframe => {
			if ( ! iframe.hasAttribute( 'title' ) ) {
				iframe.setAttribute( 'title', 'Watch video' );
			}
		} );
	}
}

export default IframeTitleChecker;
